import { DateParser, ErrorState, formatNumber, InformationBlock, Loading } from '@dec/shared';
import { Calendar2, Chat, GeoAlt } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { useDisbursement } from '../hooks/useDisbursement';

interface DisbursementCardProps {
  id: string;
}

export const DisbursementCard = ({ id }: DisbursementCardProps) => {
  const { t } = useTranslation();
  const { data: disbursement, isLoading, error, refetch } = useDisbursement(id!);

  return (
    <>
      {isLoading && <Loading />}

      {error && <ErrorState onRetry={() => void refetch()} />}

      {!isLoading && !error && (
        <div>
          <div className="card">
            <div className="card-body py-4 px-4">
              <div className="d-flex">
                <div className="me-5">
                  <InformationBlock
                    title={t('disbursement.disbursementDate')}
                    value={DateParser.toString(disbursement?.disbursementDate)}
                    icon={Calendar2}
                  />
                </div>
                <InformationBlock
                  title={t('disbursement.disbursementComments')}
                  value={disbursement?.comments ?? ''}
                  icon={Chat}
                />
              </div>
            </div>
          </div>
          <div className="row">
            {disbursement?.jurisdictions.length === 0 && (
              <div className="p-3">
                <div className="alert alert-info" role="alert">
                  {t('disbursement.noPending')}
                </div>{' '}
              </div>
            )}
            {(disbursement?.jurisdictions ?? []).map((item) => (
              <div className="col mb-2" key={item.jurisdiction}>
                <div className="card h-100">
                  <div className="card-body d-flex align-items-center py-4 px-4">
                    <div className="d-flex align-items-center gap-3 mb-4 w-100">
                      <div className="fs-2 text-primary">
                        <GeoAlt size={45} style={{ color: item.color }} />
                      </div>
                      <div className="w-100">
                        <div className="text-uppercase text-muted fw-semibold small mb-2">
                          {item.jurisdictionName}{' '}
                        </div>

                        <div className="fw-bold text-dark text-end" style={{ fontSize: '2rem' }}>
                          {formatNumber(item.value)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
